'use strict';

var $ = require('jquery');
import {debounce} from '../../components/custom-lodash';

function reformTabsUI() {
    if ($('.product-tabs-container').length == 1) {
        if ($(window).width() <= 1023) {
            $('#panelTabsContainerDesktop .product-tabs-container')
                .appendTo('#panelTabsContainerMobile')
                .removeClass('only-on-desktop')
                .addClass('hide-on-desktop');
            $('#panelTabsContainerMobile .product-tabs-container').attr('id', 'product-tabs-container-mobile');
        } else {
            $('#panelTabsContainerMobile .product-tabs-container')
                .appendTo('#panelTabsContainerDesktop .pdp-grid-top-col-left')
                .removeClass('hide-on-desktop')
                .addClass('only-on-desktop');
            $('#panelTabsContainerDesktop .product-tabs-container').attr('id', 'product-tabs-container');
        }
    }
}

exports.init = function () {
    $(window).on(
        'resize',
        debounce(function () {
            reformTabsUI();
        }, 100)
    );

    $(() => {
        var $pdpMain = $('#pdpMain');
        var $pdpProductTab = $pdpMain.find('.product-tab');

        reformTabsUI();
        $pdpProductTab.on('click', e => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            $('.tab').removeClass('tab-active');
            $('.tab[data-id="' + $this.attr('data-id') + '"]').addClass('tab-active');
            $pdpProductTab.removeClass('active');

            $pdpProductTab.attr('aria-selected', 'false');

            $this.addClass('active');
            $this.attr('aria-selected', 'true');
        });
    });
};
